import templateUrl from "emun.order/order-multi-add-options.htm";
import OrderMultiAddOptionsController from "emun.order/order-multi-add-options.controller";
import open from "webmodals/open";

let OrderMultiAddOptions = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    controller: OrderMultiAddOptionsController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderMultiAddOptions;
